<template>
  <div class="default-section">
    <component
      v-for="(item, key) in content"
      :is="`${item.type}-component`"
      :content="item.content"
      :key="key"
      class="component" />
  </div>
</template>
<script>

import TextComponent from 'components/TextComponent';
import VideoComponent from 'components/VideoComponent';
import { trackSection } from '../utils/track';


export default {
  components: {
    TextComponent,
    VideoComponent,
  },
  props: {
    content: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tracked: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.checkPosition();
    });
  },
  methods: {
    checkPosition() {
      if (this.$el.classList.contains('in-viewport') && !this.$el.classList.contains('above-viewport')) {
        this.$emit('section-change', this.name);
      }
      if (this.$el.classList.contains('in-viewport', 'above-viewport')) {
        if (!this.tracked) {
          this.tracked = true;
          trackSection(this.name);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .component {
    margin-bottom: 25px;
  }
</style>




// WEBPACK FOOTER //
// src/components/DefaultSection.vue